import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-navy px-4 py-14" aria-labelledby="situaciones" data-id="element-235" data-mp="27m279h3ozn7n">
      <div className="mx-auto w-full max-w-3xl" data-id="element-236" data-mp="27o58yye7j4s7">
        <h2 id="situaciones" className="text-center font-display text-2xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-237" data-mp="22uj1rlqtbt3s">
          Si alguna de estas situaciones te resulta familiar, esto fue creado
          para ti
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-238" data-mp="2qkwkumrf6hm8">
          {painPoints.map(point => <li key={point} className="flex gap-3 rounded-2xl border border-white/10 bg-white/5 p-4" data-id="element-239" data-mp="2qityccph76m9">
              <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brandred" aria-hidden="true" data-id="element-240" data-mp="w86swakm3ihh" />
              <p className="text-[15px] leading-snug text-white/85" data-id="element-241" data-mp="s7wm4vozwo1k">{point}</p>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-[15px] font-semibold text-white sm:text-lg" data-id="element-242" data-mp="1s6mzc0zu5acu">
          La buena noticia es que ya no necesitas depender de la memoria ni perder
          tiempo buscando respuestas.
        </p>

        <div className="mt-6" data-id="element-243" data-mp="21wzltyr7ndlm">
          <CTAButton label="Quiero dejar de improvisar en consulta" data-id="element-244" data-mp="21y0uxxoo1q0p" />
        </div>
      </div>
    </section>;
}